import { createContext, useContext, useEffect, useState } from "react";
import { CONTENT } from "./content";

const LangCtx = createContext(null);

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(() => {
        try {
            return localStorage.getItem("star-lang") === "es" ? "es" : "en";
        } catch (e) {
            return "en";
        }
    });
    useEffect(() => {
        document.documentElement.lang = lang;
        try {
            localStorage.setItem("star-lang", lang);
        } catch (e) {}
    }, [lang]);
    return (
        <LangCtx.Provider
            value={{
                lang,
                setLang,
                c: CONTENT[lang],
                setEn: () => setLang("en"),
                setEs: () => setLang("es"),
            }}
        >
            {children}
        </LangCtx.Provider>
    );
}

export const useLang = () => useContext(LangCtx);
